module.exports = __webpack_public_path__ + "static/media/nike-never-ask-koblova.b8909704.mp4";